import config from "../../config";

export const apiUrl = (append = "") => {
    return [
        config.api.baseUrl, 
        config.api.version,
        append
    ].map((part) => part.replace(/^\/|\/$/g, '')).join("/");
};
